import { defineStore } from 'pinia';
import axios from 'axios';

export const useAuthStore = defineStore('authStore', {
    state: () => ({
        user: null,
    }),

    getters: {
        isUserM7() {
            return (
                this.user?.groups?.some(group => group.name === 'M7') || false
            );
        }
    },

    actions: {
        async login(form) {
            const { data } = await axios.post('auth/login', form, {
                baseURL: import.meta.env.VITE_API_ENDPOINT
            });
            localStorage.setItem('access-token', data.token);
        },

        async logout() {
            await axios.get('auth/logout', {
                baseURL: import.meta.env.VITE_API_ENDPOINT
            });
            localStorage.removeItem('access-token');
        },

        async refreshToken() {
            const { data } = await axios.get('auth/refresh-token', {
                baseURL: import.meta.env.VITE_API_ENDPOINT
            });
            return data;
        },

        async fetchUser(params = {}) {
            params['includes'] = [];
            const { data } = await axios.get('auth/me', {
                baseURL: import.meta.env.VITE_API_ENDPOINT,
                params: params
            });

            this.user = data;
        },
    }
});
